export default {
    Aruba: "Aruba",
    Bolivia: "Bolivia",
    Brazil: "Brazil",
    Colombia: "Colombia",
    " Dominican Republic": "Dominican Republic",
    Ecuador: "Ecuador",
    England: "England",
    "French Guiana": "French Guiana",
    Mexico: "Mexico",
    Nicaragua: "Nicaragua",
    Panama: "Panama",
    Paraguay: "Paraguay",
    "Puerto Rico": "Puerto Rico",
    "Saint Martin": "Saint Martin",
    "Trinidad and Tobago": "Trinidad and Tobago",
    "United States": "United States",
    Uruguay: "Uruguay",
    Venezuela: "Venezuela",
}
